/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1PublishinghousegroupsQueryResponse } from '../../types/GetV1Publishinghousegroups.ts'

export const getV1PublishinghousegroupsQueryKey = () =>
    [{ url: '/v1/PublishingHouseGroups' }] as const

export type GetV1PublishinghousegroupsQueryKey = ReturnType<
    typeof getV1PublishinghousegroupsQueryKey
>

/**
 * {@link /v1/PublishingHouseGroups}
 */
export async function getV1Publishinghousegroups(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1PublishinghousegroupsQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/PublishingHouseGroups`, ...requestConfig })
    return res
}

export function getV1PublishinghousegroupsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1PublishinghousegroupsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1PublishinghousegroupsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1PublishinghousegroupsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Publishinghousegroups(config)
        },
    })
}

/**
 * {@link /v1/PublishingHouseGroups}
 */
export function useGetV1Publishinghousegroups<
    TData = ResponseConfig<GetV1PublishinghousegroupsQueryResponse>,
    TQueryData = ResponseConfig<GetV1PublishinghousegroupsQueryResponse>,
    TQueryKey extends QueryKey = GetV1PublishinghousegroupsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1PublishinghousegroupsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1PublishinghousegroupsQueryKey()

    const query = useQuery(
        {
            ...getV1PublishinghousegroupsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
